import { render, staticRenderFns } from "./ProductAttachmentsComponent.vue?vue&type=template&id=f89c4e6a&"
import script from "./ProductAttachmentsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductAttachmentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttachmentsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports